export default __webpack_public_path__ + "static/media/eye-off.5a68bfef.svg";